export function ResumeLink({ text }: { text?: string }) {
  return (
    <a href="/Vincent-Liaw-Resume-2024.pdf" download>
      {text ?? 'Resume'}
    </a>
  );
}